<template>
    <div><!-- COA&異常連結單回覆總表 -->
        <CCard>
            <CCardBody>
                <div class="d-flex justify-content-end mb-2">
                    <button class="btn btn-sm btn-dark ml-2" @click="$router.go(-1)">{{$t('Buttons.GoBack')}}</button>
                </div>
                <VueTreeGrid :class="treeGridClass" v-if="isShowTreeGrid" :columns="treeColumns" :tree="dataTree">
                    <template v-if="isCoa" slot="coaTotcnt--row-cell" slot-scope="scope">
                        <div class="total" v-if="scope.row._level === 1">{{scope.row.coaTotcnt}}</div>
                        <div class="total_container" v-if="scope.row._level === 2">
                            <p>{{scope.row.coaDtlNum}}</p>
                            <p>{{scope.row.coaCnt}}</p>
                        </div>
                    </template>
                    <template v-if="isJqm" slot="jqmCnt--row-cell" slot-scope="scope">
                        <div class="total" v-if="scope.row._level === 1">{{scope.row.jqmCnt}}</div>
                        <div class="total_container" v-if="scope.row._level === 2">
                            <p>{{scope.row.jqmDtlNum}}</p>
                            <p>{{scope.row.jqmDtlName}}</p>
                        </div>
                    </template>
                    <template slot="action--row-cell" slot-scope="scope">                        
                        <router-link class="btn btn-sm btn-success" @click.native="viewEvent(scope.row)"  to="">{{i18n('Buttons.DetailInfo')}}</router-link>
                    </template>
                </VueTreeGrid>            
            </CCardBody>
        </CCard>
    </div>
</template>
<script>
import VueTreeGrid from '@reallife/vue-tree-grid' 
import { qualityMixin } from '@/mixin/quality'
import { mapGetters } from 'vuex'
export default {
    mixins: [qualityMixin],	
    components: {
        VueTreeGrid,
    },
    data() {
        return {
            isCoa : false,
            isJqm : false,
            isCar : false,
            isShowTreeGrid : false,
            coaColumns: [                
                {width: "2%",label: "",},
                {type: "prop",prop: "coaCreateDateTxt",label: this.i18n("Generaltable.EstablishedDate")}, 
                {type: "prop",prop: "vendor",label: this.i18n("Generaltable.Vendor")}, 
                {type: "prop",prop: "po",label: "PO_NO"}, 
                {type: "prop",prop: "partnumber",label: this.i18n("Generaltable.PartNumber")}, 
                {type: "prop",prop: "partname",label: this.i18n("Generaltable.Parts")}, 
                {type: "prop",prop: "coaTotcnt",label: this.i18n("Generaltable.TotalQuantity")},                 
                {type: "prop",prop: "coaStatusTxt",label: this.i18n("Generaltable.Status"),width: "10%"},
                {type: "prop",prop: "action",label: this.i18n("Generaltable.Function")}
            ],
            jqmColumns: [                
                {width: "2%",label: "",}, 
                {type: "prop",prop: "jqmCreateDateTxt",label: this.i18n("Generaltable.EstablishedDate")}, 
                {type: "prop",prop: "jqmUpdateDateTxt",label: this.i18n("Generaltable.InputTime")}, 
                {type: "prop",prop: "vendor",label: this.i18n("Generaltable.Vendor")},                 
                {type: "prop",prop: "jqmYearmonth",label: this.i18n("Generaltable.YearAndMonthAssigned")}, 
                {type: "prop",prop: "jqmWeek",label: this.i18n("Generaltable.WeekAssigned")}, 
                {type: "prop",prop: "jqmCnt",label: this.i18n("Generaltable.TotalQuantity")},                 
                {type: "prop",prop: "jqmStatusTxt",label: this.i18n("Generaltable.Status"),width: "10%"},
                {type: "prop",prop: "action",label: this.i18n("Generaltable.Function")}
            ],
            carColumns: [                
                {width: "2%",label: "",}, 
                {type: "prop",prop: "happenDateTxt",label: this.i18n("Generaltable.OccuranceDates")}, 
                {type: "prop",prop: "vendor",label: this.i18n("Generaltable.Vendor")},                 
                {type: "prop",prop: "partnumber",label: this.i18n("Generaltable.PartNumber")}, 
                {type: "prop",prop: "partname",label: this.i18n("Generaltable.Parts")}, 
                {type: "prop",prop: "happenTypeTxt",label: this.i18n("Generaltable.OccuranceType")}, 
                {type: "prop",prop: "carCnt",label: this.i18n("Generaltable.NumberOfAbnormalities")}, 
                {type: "prop",prop: "carRatio",label: this.i18n("Generaltable.DefectRate")}, 
                {type: "prop",prop: "carContent",label: this.i18n("Generaltable.ContentOfAbnormalities")}, 
                {type: "prop",prop: "carEnddateTxt",label: this.i18n("Generaltable.ClosingDate")}, 
                {type: "prop",prop: "carStatusTxt",label: this.i18n("Generaltable.Status"),width: "10%"}, 
                {type: "prop",prop: "action",label: this.i18n("Generaltable.Function")}
            ],
            carStatusList: this.$t('carStatusList'), //狀態 清單
            carHappenTypeList: this.$t('carHappenTypeList'), //發生類別 清單
            dataTree: [],
        }
    },
    computed: {
        ...mapGetters(["lang"]),
       treeColumns (){
           const {isCoa , isCar , isJqm} = this;
           if(isCoa){               
               return this.coaColumns;
           }else if(isCar){
               return this.carColumns;
           }else if(isJqm){
               return this.jqmColumns;
           }
       },
       treeGridClass (){
           const {isCoa , isCar , isJqm} = this;
           if(isCoa){               
               return 'subTreeStyle coaTreeStyle';
           }else if(isCar){
               return 'carTreeStyle';
           }else if(isJqm){
               return 'subTreeStyle jqmTreeStyle';
           }
       }
    },
	mounted() {
        const gtLinkType = sessionStorage.getItem('gtLinkType');
        const vendorId = sessionStorage.getItem('gtLinkVendor');
        if(gtLinkType && vendorId){        
            if(gtLinkType === 'coa')    {
                this.isCoa = true;
                this.queryCoaList(vendorId);
            }else if(gtLinkType === 'car')    {
                this.isCar = true;
                this.queryCarList(vendorId);
            }else if(gtLinkType === 'jqm')    {
                this.isJqm = true;
                this.queryJqmList(vendorId);
            }            
            this.isShowTreeGrid = true;
        }
	},
    props : {
    },
    watch: {
        "lang": function() {
            this.coaColumns = [                
                {width: "2%",label: "",},
                {type: "prop",prop: "coaCreateDateTxt",label: this.i18n("Generaltable.EstablishedDate")}, 
                {type: "prop",prop: "vendor",label: this.i18n("Generaltable.Vendor")}, 
                {type: "prop",prop: "po",label: "PO_NO"}, 
                {type: "prop",prop: "partnumber",label: this.i18n("Generaltable.PartNumber")}, 
                {type: "prop",prop: "partname",label: this.i18n("Generaltable.Parts")}, 
                {type: "prop",prop: "coaTotcnt",label: this.i18n("Generaltable.TotalQuantity")},                 
                {type: "prop",prop: "coaStatusTxt",label: this.i18n("Generaltable.Status"),width: "10%"},
                {type: "prop",prop: "action",label: this.i18n("Generaltable.Function")}
            ]
            this.jqmColumns = [                
                {width: "2%",label: "",}, 
                {type: "prop",prop: "jqmCreateDateTxt",label: this.i18n("Generaltable.EstablishedDate")}, 
                {type: "prop",prop: "jqmUpdateDateTxt",label: this.i18n("Generaltable.InputTime")}, 
                {type: "prop",prop: "vendor",label: this.i18n("Generaltable.Vendor")},                 
                {type: "prop",prop: "jqmYearmonth",label: this.i18n("Generaltable.YearAndMonthAssigned")}, 
                {type: "prop",prop: "jqmWeek",label: this.i18n("Generaltable.WeekAssigned")}, 
                {type: "prop",prop: "jqmCnt",label: this.i18n("Generaltable.TotalQuantity")},                 
                {type: "prop",prop: "jqmStatusTxt",label: this.i18n("Generaltable.Status"),width: "10%"},
                {type: "prop",prop: "action",label: this.i18n("Generaltable.Function")}
            ]
            this.carColumns = [                
                {width: "2%",label: "",}, 
                {type: "prop",prop: "happenDateTxt",label: this.i18n("Generaltable.OccuranceDates")}, 
                {type: "prop",prop: "vendor",label: this.i18n("Generaltable.Vendor")},                 
                {type: "prop",prop: "partnumber",label: this.i18n("Generaltable.PartNumber")}, 
                {type: "prop",prop: "partname",label: this.i18n("Generaltable.Parts")}, 
                {type: "prop",prop: "happenTypeTxt",label: this.i18n("Generaltable.OccuranceType")}, 
                {type: "prop",prop: "carCnt",label: this.i18n("Generaltable.NumberOfAbnormalities")}, 
                {type: "prop",prop: "carRatio",label: this.i18n("Generaltable.DefectRate")}, 
                {type: "prop",prop: "carContent",label: this.i18n("Generaltable.ContentOfAbnormalities")}, 
                {type: "prop",prop: "carEnddateTxt",label: this.i18n("Generaltable.ClosingDate")}, 
                {type: "prop",prop: "carStatusTxt",label: this.i18n("Generaltable.Status"),width: "10%"}, 
                {type: "prop",prop: "action",label: this.i18n("Generaltable.Function")}
            ]

            this.carStatusList = this.$t('carStatusList') //狀態 清單
            this.carHappenTypeList = this.$t('carHappenTypeList') //發生類別 清單
        }
    },
    methods: {
        queryCoaList (vendorId){
            const self = this;
            const url = `${this.$apiUrl_Quality}/SearchCoaUpload`;
            const param = {vendorId:vendorId ,includeSubTree : 'Y'};
            this.updateLoading(true);
            this.axios.post(url, param).then((response) => {
                const {status , statusMessage} = response.data;
                this.updateLoading(false);
                if(status){
                    this.$alert(statusMessage,'警告',{type: 'warning'});
                }else{                    
                    //--成功                    
                    const rowStatusMap= this.listToMap(this.$t('rowStatusList'), 'rowStatusId' ,'rowStatusCaption');
                    const rows = response.data;
                    rows.forEach(r => {
                        let rowStatusTxt = '';
                        let rowStatus = '';
                        if(r.coaStatus === 0){
                            rowStatus ='A';
                        }else if(r.coaStatus === 1){
                            rowStatus ='B';
                        }else if(r.coaStatus === 2){
                            rowStatus ='C';
                        }
                        if(rowStatus){
                            rowStatusTxt = rowStatusMap[rowStatus];
                        }
                        r.coaCreateDateTxt = self.fixDateTime(r.coaCreateDate);
                        r.coaStatusTxt = rowStatusTxt;
                        const children = [{coaDtlNum : '批次' , coaCnt : '數量' }];
                        if(r.coaDtlList && r.coaDtlList.length){
                            r.coaDtlList.forEach(e => {
                                children.push({coaDtlNum :e.coaDtlNum , coaCnt :e.coaCnt })
                            });
                        }
                        r.children = children;
                        r.coaDtlList =null;
                    });
                    this.dataTree = rows;                    
                }                    
            }); 
        },
        queryCarList (vendorId){
            const self = this;
            const url = `${this.$apiUrl_Quality}/SearchUnusualElement`;
            const param = {vendorId:vendorId,includeSubTree : 'Y'};
            this.updateLoading(true);
            this.axios.post(url, param).then((response) => {
                const {status , statusMessage} = response.data;
                this.updateLoading(false);
                if(status){
                    this.$alert(statusMessage,'警告',{type: 'warning'});
                }else{                    
                    //--成功          
                    const carStatusMap= this.listToMap(this.carStatusList, 'carStatusId' ,'carStatusCaption');
                    const carHappenMap= this.listToMap(this.carHappenTypeList, 'happenTypeId' ,'happenTypeCaption');
                    const rows = response.data;
                    rows.forEach(r => {
                        const rowStatus = ''+r.carStatus;                        
                        r.happenDateTxt = self.fixDate(r.happenDate);
                        r.carEnddateTxt = self.fixDate(r.carEnddate);
                        r.carStatusTxt = carStatusMap[rowStatus];
                        r.happenTypeTxt = carHappenMap[r.happenType];
                    });
                    this.dataTree = rows;                    
                }                    
            }); 
        },
        queryJqmList (vendorId){
            const self = this;
            const url = `${this.$apiUrl_Quality}/SearchJqmUpload`;
            const param = {vendorId:vendorId,includeSubTree : 'Y'};
            this.updateLoading(true);
            this.axios.post(url, param).then((response) => {
                const {status , statusMessage} = response.data;
                this.updateLoading(false);
                if(status){
                    this.$alert(statusMessage,'警告',{type: 'warning'});
                }else{                    
                    //--成功
                    const rowStatusMap= this.listToMap(this.$t('rowStatusList'), 'rowStatusId' ,'rowStatusCaption');
                    const rows = response.data;                    
                    rows.forEach(r => {
                        let rowStatusTxt = '';
                        let rowStatus = '';
                        if(r.jqmStatus === 0){
                            rowStatus ='A';
                        }else if(r.jqmStatus === 1){
                            rowStatus ='B';
                        }else if(r.jqmStatus === 2){
                            rowStatus ='C';
                        }
                        if(rowStatus){
                            rowStatusTxt = rowStatusMap[rowStatus];
                        }                        
                        r.jqmStatusTxt = rowStatusTxt;
                        r.jqmCreateDateTxt = self.fixDateTime(r.jqmCreateDate);
                        r.jqmUpdateDateTxt = self.fixDateTime(r.jqmUpdateDate);
                        const children = [{jqmDtlNum : '分群碼' , jqmDtlName : '分群碼(中文)' }];
                        if(r.jqmDtlList && r.jqmDtlList.length){
                            r.jqmDtlList.forEach(e => {
                                children.push({jqmDtlNum :e.jqmDtlNum , jqmDtlName :e.jqmDtlName })
                            });
                        }
                        r.children = children;
                        r.jqmDtlList =null;
                    });
                    this.dataTree = rows;                    
                }                    
            }); 
        },
        viewEvent (item){
            const {isCoa , isCar , isJqm} = this;
           if(isCoa){               
               return this.viewCoaEvent(item);
           }else if(isCar){
               return this.viewCarEvent(item);
           }else if(isJqm){
               return this.viewJqmEvent(item);
           }
        },
        viewCoaEvent (item){
            sessionStorage.setItem('coaGuid', item.coaGuid);
            this.$router.push('coainformation');
        },
        viewJqmEvent (item){
            sessionStorage.setItem('jqmGuid', item.jqmGuid);
            this.$router.push('jqminformation');
        },
        viewCarEvent (item){
            sessionStorage.setItem('carGuid', item.carGuid);
            this.$router.push('elementinformation');
        },
        i18n (keyStr){
            return this.$t(keyStr);
        },
    },
    created() {        
    }
}
</script>
<style lang="scss" scoped>
table th:first-child {
    text-align: center;
    padding: 15px 5px;
}
.table th {
    background-color: #BDD6EE;
    color: #000;
}
.table, .table-bordered th, .table-bordered td {
    border-color: black;
}
.tree-grid__body-row--level-2 .tree-grid__body-cell .btn {
    display: none;
}
.total_container {
    display: flex;
    height: 100%;    
    p {
        padding: 0 1rem;
        margin-bottom: 0;
    }
    p:last-child {
        border-left: 1px solid black;
    }
}
</style>
<style lang="scss" >
.tree-grid__body-row .tree-grid__body-cell .tree-grid__expand-icon {
  background-color: #4062c2!important;
  border-radius: 50%!important;
  color: #fff;
  line-height: 17px!important;
  width: 20px!important;
  height: 20px!important;
  margin-left: -30px;
}

.tree-grid__body-row .tree-grid__body-cell i.tree-grid__expand-icon.tree-grid__expand-icon--expanded {
  background-color: #e55353!important;
}

.tree-grid__table th {
  background-color: #BDD6EE;
  color: #000;
}

div.subTreeStyle .tree-grid__body-row .tree-grid__body-cell:nth-child(7) {
  text-align: right;
}

div.subTreeStyle .tree-grid__body-row .tree-grid__body-cell:nth-child(7),.tree-grid__body-row.tree-grid__body-row--level-2 .tree-grid__body-cell:nth-child(7) {
  // color: red;
  border: 1px solid black;
  padding: 0;
  height: 1px;
  vertical-align: middle;
    .total {
        margin-right: 1rem;
    }
}
div.coaTreeStyle .total_container:first-child {
    p:first-child {
    flex: .7;
    width: 150px;
    }
    p:last-child {
    flex: .3;
    }
}
div.jqmTreeStyle .total_container:first-child {
    p:first-child {
    flex: .3;
    width: 150px;
    }
    p:last-child {
    flex: .7;
    }
}
.tree-grid__body-row--level-2 {
  .tree-grid__body-cell {
    border-top: none !important;
  }
}
</style>


